<template>
  <b-modal id="reason-modal" ref="reason-modal" :title="title" size="xl" :hide-header-close="true"
    :no-close-on-backdrop="true" @cancel="resetModal" @hide="resetModal">
    <b-overlay :show="loading">
      <b-container fluid class="p-0">
        <form ref="form" @submit.stop.prevent="handleSubmit">
          <b-row>
            <b-col>
              <basic-text-editors label="Nội dung" placeholder="Vui lòng nhập lý do ..." name="answer"
                :value.sync="form.answer" data-vv-as="Vui lòng nhập lý do ...">
              </basic-text-editors>
            </b-col>
          </b-row>
          <b-row v-if="canSendSms" class="mt-3">
            <b-col>
              <b-form-checkbox v-model="sendSms" switch>
                Gửi SMS thông báo cho khách hàng
              </b-form-checkbox>
              <small class="text-muted">
                Mặc định không nhắn tin. Chỉ chọn khi muốn gửi SMS thông báo cho khách.
              </small>
            </b-col>
          </b-row>
        </form>
      </b-container>
    </b-overlay>
    <template #modal-footer>
      <div class="w-100 d-flex align-items-center justify-content-end">
        <b-button class="btn btn-plain ml-2" href="#" @click.stop="handleCancel" tabindex="0">
          Huỷ
        </b-button>
        <b-button class="btn btn-success ml-2" href="#" @click.stop="handleSubmit" tabindex="0">
          <span class="svg-icon">
            <inline-svg src="/media/svg/icons/Neolex/Basic/save.svg" />
          </span>
          Cập nhật
        </b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
const POTENTIAL_TITLE = 'Lý do chuyển người dùng thành khách hàng tiềm năng';

export default {
  name: 'ReasonModal',
  components: {},
  props: {
    targetItem: {
      type: Object,
      required: true,
    },
    title: {
      type: String,
      required: false,
    },
  },
  computed: {
    type() {
      return this.popupType;
    },
    // Modal dùng chung cho nhiều thao tác, chỉ nhánh tiềm năng mới có SMS để hỏi
    isPotentialFlow() {
      return this.title === POTENTIAL_TITLE;
    },
    // Khách chỉ dùng Zalo/Google (isZaloLinked true/false) không có SDT thật để nhận SMS -
    // chỉ true/false là biết chắc (BE đã hỏi IS), null/undefined mới là còn chưa xác định
    // hoặc là SDT thật.
    canSendSms() {
      return this.isPotentialFlow && this.targetItem?.isZaloLinked == null;
    },
  },
  watch: {
    id: {
      deep: true,
      handler(newVal) {
        if (newVal) {
          this.loadData(newVal);
        }
      },
    },
    form: {
      deep: true,
      handler(newVal) {
        if (
          Object.keys(newVal).length &&
          this.initialFrom !== JSON.stringify(newVal)
        ) {
          this.isChange = true;
        }
      },
    },
  },
  data() {
    return {
      detail: {},
      validationState: {},
      error: {},
      form: {
        answer: '',
      },
      loading: false,
      isChange: null,
      initialFrom: null,
      // Mặc định TẮT: chỉ nhắn tin khi admin chủ động tick
      sendSms: false,
    };
  },

  methods: {
    async handleSubmit() {
      // Modal dùng chung cho nhiều thao tác (đổi title), nên chữ cảnh báo để chung chung
      const confirmed = await this.$swal({
        title: 'Xác nhận?',
        text: 'Bạn có chắc chắn muốn lưu thay đổi này?',
        icon: 'warning',
        buttons: {
          cancel: {
            text: 'Huỷ',
            value: false,
            visible: true,
            className: '',
            closeModal: true,
          },
          confirm: {
            text: 'Xác nhận',
            value: true,
            visible: true,
            className: '',
            closeModal: true,
          },
        },
      });

      if (!confirmed) return;

      // Chụp lại giá trị TRƯỚC khi ẩn modal: $bvModal.hide kích @hide -> resetModal,
      // nên đọc this.sendSms / this.form.answer sau đó là đã bị xoá về mặc định.
      const snapshot = {
        sendSms: this.canSendSms ? this.sendSms : false,
        answer: this.form.answer,
      };

      this.$bvModal.hide('reason-modal');
      try {
        await this.changeStatus(this.targetItem, snapshot);
      } catch (error) {
        this.$toastr.e({
          title: 'Lỗi !',
          msg: error,
        });
      }
    },

    async changeStatus(item, snapshot) {
      this.$store.commit('context/setLoading', true);
      const formData = new FormData();
      const keyBoolean = [
        'followOaFlag',
        'joinGroupchatFlag',
        'downloadAppFlag',
        'loginFlag',
        'boardingBookingFlag',
        'boardingTestingFlag',
        'boardingDoneFlag',
        'joinHeathCourseFlag',
        'isDeleted',
      ];
      Object.keys(item).forEach((key) => {
        if (key == 'isDeleted') {
          formData.append('isDeleted', !!item.isDeleted);
        } else if (key === 'timeAccepted' || key === 'gender') {
          //
        } else if (key === 'status') {
          const newStatus = this.isPotentialFlow ? 9 : 0;
          formData.set('status', newStatus);
          formData.append('ReasonOut', snapshot.answer ?? '');
          // Only append gender if it has a valid value (1 or 2)
          if (item.gender === 1 || item.gender === 2) {
            formData.append('gender', item.gender);
          }
        } else{
          formData.append(
            key,
            keyBoolean.includes(key) ? !!item[key] : item[key] || '',
          );
        }
      });
      formData.set('sendSmsNotJoin', snapshot.sendSms);
      try {
        await this.$api.put(`/CustomerReceives/${item.id}`, formData, { timeout: 60000 });
        this.$toastr.s({
          title: 'Thành công !',
          msg: 'Cập nhật thành công',
        });
      } catch (error) {
        if (error) {
          return this.$toastr.e({
            title: 'Lỗi !',
            msg: error.message,
          });
        }
      } finally {
        this.$store.commit('context/setLoading', false);
        this.$emit('load-data');
      }
    },
    resetModal() {
      this.form = {};
      this.initialFrom = {};
      this.isChange = false;
      this.sendSms = false;
    },
    handleCancel() {
      this.$bvModal.hide('reason-modal');
    },
  },
  mounted() {
    if (this.form && this.targetItem) {
      this.$set(this.form, 'answer', this.targetItem.reasonOut);
    }
  },
};
</script>

<style lang="scss"></style>